import React from 'react'
import { BarLabelProps } from '@mui/x-charts'
import { animated, to } from '@react-spring/web'

export const BarLabel = (props: BarLabelProps) => {
  const { seriesId, dataIndex, color, isFaded, isHighlighted, classes, style, ...otherProps } =
    props

  const pathY = to([style?.y, style?.height], (y: number, height: number) => y - height / 2 - 4)

  return (
    <animated.text
      {...otherProps}
      fill='black'
      textAnchor='middle'
      style={{
        x: style?.x,
        y: pathY,
      }}
    />
  )
}
